<template>
    <div>
        <app-overlay-loader v-if="preloader"/>
        <form v-else
            ref="form"
            method="post"
            :data-url="`${TENANT_BASE_URL}general/settings/editable-transaction-time`"
            @submit.prevent="submitData"
            enctype="multipart/form-data"
            class="mb-0"
            :class="{'loading-opacity': preloader}">

            <!-- Edit Time Setting -->
            <fieldset class="form-group mb-5">
                <div class="row">
                    <div class="col-md-12">
                        <app-form-group
                            page="page"
                            :label="$t('editable_transaction_time')"
                            type="number"
                            v-model="settings.editable_transaction_time"
                            :error-message="$errorMessage(errors, 'editable_transaction_time')"
                            :required="true"
                            :min="1"
                        />
                    </div>
                </div>
            </fieldset>

            <div class="mt-5">
                <app-submit-button
                    :loading="loading"
                    @click="submitData"
                />
            </div>
        </form>
    </div>
</template>

<script>
import {mapState, mapActions} from 'vuex';
import {formDataAssigner} from '../../../../../common/Helper/Support/FormHelper'
import FormHelperMixins from "../../../../../common/Mixin/Global/FormHelperMixins"
import {TENANT_BASE_URL} from "../../../../../common/Config/UrlHelper";

export default {
    name: "EditTimeSetting",
    mixins: [FormHelperMixins],
    data() {
        return {
            TENANT_BASE_URL,
            settings: {},
            preloader: true
        }
    },
    methods: {
        beforeSubmit() {
            this.preloader = true;
            this.loading   = true;
            this.message   = '';
            this.errors    = {};
        },
        submitData() {
            this.beforeSubmit();
            if (!this.settings.editable_transaction_time) {
                this.preloader = false;
                this.loading   = false;
                this.$toastr.e(this.$t('invalid_data'));
                return;
            }

            let formData = formDataAssigner(new FormData, {
                editable_transaction_time: this.settings.editable_transaction_time
            });
            return this.save(formData);
        },
        afterSuccess({data}) {
            this.toastAndReload(data.message);
            location.reload();
        },
        ...mapActions([
            'getTenantSettings'
        ])
    },
    computed: {
        ...mapState({
            generalSettings: state => state.tenant_settings.tenantSettings
        })
    },
    created() {
        this.getTenantSettings();
        this.preloader = true;
    },
    watch: {
        generalSettings: {
            handler: function (settings) {
                if (!Object.keys(this.settings).length) {
                    for (const key in settings) {
                        if (![
                            'editable_transaction_time',
                        ].includes(key)) {
                            continue
                        }
                        this.settings[key] = settings[key];
                    }
                    this.preloader = false;
                }
            },
            deep: true
        }
    }
}
</script>